export default "__VITE_ASSET__Crke4qGM__"